var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.38388 11.1161C7.87204 11.6043 7.87204 12.3957 7.38388 12.8839C6.89573 13.372 6.10427 13.372 5.61612 12.8839L0.616116 7.88388C0.12796 7.39573 0.12796 6.60427 0.616116 6.11612L5.61612 1.11612C6.10427 0.62796 6.89573 0.62796 7.38388 1.11612C7.87204 1.60427 7.87204 2.39573 7.38388 2.88388L3.26777 7L7.38388 11.1161Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/LeftArrow.8cd2cb1a42751ae886e0eaa58a20b2b3.svg";
export { ForwardRef as ReactComponent };